import React from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

import PaperMaterial from '@material-ui/core/Paper';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import BusinessIcon from '@material-ui/icons/Business';

import Corporations from './Corporations';
import Packages from './Packages';
import Users from './Users';
import Appointments from './Appointments';
import AppointmentsTime from './AppointmentsTime';

const useStyles = makeStyles(() => ({
  root: {
    padding: '15px 0px 0px 0px',
  },
}));

function Tabs() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <TabContext value={value}>
      <PaperMaterial>
        <TabList
          variant="scrollable"
          textColor="secondary"
          onChange={handleChange}
        >
          <Tab
            icon={<BusinessIcon />}
            label={t('dashboard.tabs.corporations')}
            value="1"
          />
          <Tab
            icon={<ShoppingCartIcon />}
            label={t('dashboard.tabs.packages')}
            value="2"
          />
          <Tab
            icon={<PeopleIcon />}
            label={t('dashboard.tabs.users')}
            value="3"
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('dashboard.tabs.appointments')}
            value="4"
          />
          <Tab
            icon={<LocalHospitalIcon />}
            label={t('dashboard.tabs.appointmentsTime')}
            value="5"
          />
        </TabList>
      </PaperMaterial>

      <TabPanel className={classes.root} value="1">
        <Corporations />
      </TabPanel>

      <TabPanel className={classes.root} value="2">
        <Packages />
      </TabPanel>

      <TabPanel className={classes.root} value="3">
        <Users />
      </TabPanel>

      <TabPanel className={classes.root} value="4">
        <Appointments />
      </TabPanel>

      <TabPanel className={classes.root} value="5">
        <AppointmentsTime />
      </TabPanel>
    </TabContext>
  );
}

export default React.memo(withRouter(Tabs));
